'use client';
import { createAnalyticsContext } from '@s7/base';

const CLICK_CTA_EVENT = 'click_cta';
const topics = {
    navigation: {
        openTab: (from, to)=>[
                CLICK_CTA_EVENT,
                {
                    result: 'open_tab',
                    flow: from,
                    step: to
                }
            ]
    }
};
const [AnalyticsProvider, useAnalytics] = createAnalyticsContext(topics);

export { AnalyticsProvider, useAnalytics };
//# sourceMappingURL=analytics.js.map
